import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, DocumentReference } from '@angular/fire/firestore';
import { Customer } from './customer.model';

@Injectable({
    providedIn: "root"
})
export class CustomerService {
    constructor(public firestore: AngularFirestore) {
    }

    public getPropertyTypes() {
        return this.firestore.collection(`propertyTypes`).get().toPromise()
    }

    public getCollection(): AngularFirestoreCollection {
        const collection = this.firestore.collection(`customers`);
        return collection;
    }

    public getCustomer(customerId: string){
      return  this.getCollection().doc(customerId).ref.get()
    }

    public addCustomer(customer: Customer): Promise<DocumentReference> {
        return this.getCollection().add(customer);
    }

    public updateCustomer(customer: Customer, id: any) {
        return this.getCollection().doc(id).update(customer)
    }

    public deleteCustomer(customerId: string) {
        if (customerId) {
            return this.getCollection().doc(customerId).delete().then(() => { return true });
        }
        return false;
    }
}
